export default Object.freeze({
    FEMENINO: 'M',
    MASCULINO: 'H'
})
